import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { UserRole } from '~/api/account/accountApiTypes';
import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { getAuthorByName } from '~/atomic/page/author/author.data';
import { authorSelector } from '~/atomic/page/author/author.selector';
import { SCAuthorPage } from '~/atomic/page/author/styled';
import { AuthorSubscribers } from '~/atomic/page/author/subscribers/AuthorSubscribers';
import { getAuthorSubscribers } from '~/atomic/page/author/subscribers/authorSubscribers.data';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { getAuthTokenFromServer } from '~/feature/authorization/getAuthToken';
import { getPagingFromUrl } from '~/feature/pagination/pagination.data';
import { AuthorTemplate } from '~/feature/template/AuthorTemplate';
import {
  createStore, RootState,
  useAppSelector,
} from '~/store';

const AuthorSubscribersPage:NextPage & LayoutType = () => {
  const { currentAuthor } = useAppSelector(authorSelector);
  const title = `Следите за новыми книгами автора ${currentAuthor.name ?? ''} на Букривер`;
  const description = `Все новые книги и новости от автора ${
    currentAuthor.name ?? ''}. Читайте и общайтесь с автором. `;

  return (
    <PageTemplate
      isPublic={pagesConfigStore.authorSubscribers.isPublic}
      seo={{
        title,
        description,
        image: currentAuthor?.photoUrl,
        canonical: pagesConfigStore.authorSubscribers.as(currentAuthor?.username),
        customSeoTags: (
          <meta name="robots" content="noindex, nofollow" />
        ),
      }}
      content={(
        <SCAuthorPage>
          <AuthorSubscribers />
        </SCAuthorPage>
      )}
    />
  );
};

AuthorSubscribersPage.getLayout = (page) => (
  <AuthorTemplate>{ page }</AuthorTemplate>
);

export const getServerSideProps: GetServerSideProps<
{ state: RootState; },
{ authorUsername: string; }
> = async (context) => {
  const { dispatch, store } = await createStore();
  await checkAuthToken(context, dispatch);
  const token = getAuthTokenFromServer(context);

  const authorUsername = context.params?.authorUsername ?? '';

  try {
    await dispatch(getAuthorByName({ username: authorUsername, token }));

    let state = store.getState();

    const { author: { currentAuthor } } = state;

    if (!currentAuthor?.id) {
      return { notFound: true };
    }

    if (currentAuthor.role !== UserRole.author) {
      return {
        redirect: {
          destination: pagesConfigStore.user.as(currentAuthor.username),
          permanent: false,
        },
      };
    }

    await dispatch(getPagingFromUrl(context));
    await dispatch(getAuthorSubscribers({ username: (authorUsername) }));

    state = store.getState();

    return { props: { state } };
  } catch (error) {
    console.log('error on page', { error });
    const state = store.getState();
    return { props: { state } };
  }
};

export default AuthorSubscribersPage;
